import Vue from 'vue'
import Router from 'vue-router'
import backendMod from '@/components/backendMod'
import index from '@/components/pages/index'
import download from '@/components/pages/download'
import service from '@/components/pages/service'
import price from '@/components/pages/price'
import about from '@/components/pages/about'
import casus from '@/components/pages/casus'
import background from '@/components/pages/background'
import jobs from '@/components/pages/jobs'
import learn from '@/components/pages/learn'
import problem from '@/components/pages/problem'
import getEmail from '@/components/pages/getEmail'
import sendEmail from '@/components/pages/sendEmail'
import chrome from '@/components/pages/chrome'
import dingding from '@/components/pages/dingding'
import qiwei from '@/components/pages/qiwei'
import customizedService from '@/components/pages/customizedService'
import cases from '@/components/pages/cases'
import whoAreWe from '@/components/pages/whoAreWe'
import channelsSupport from '@/components/pages/channelsSupport'
import downloadCenter from '@/components/pages/downloadCenter'
import chromeNew from '@/components/pages/chromeNew'


// import notice from '@/components/pages/learn/notice'
// import workbench from '@/components/pages/learn/workbench'
// import explain from '@/components/pages/learn/explain'
// import process from '@/components/pages/learn/process'
// import candidate from '@/components/pages/learn/candidate'
// import register from '@/components/pages/learn/register'
// import interview from '@/components/pages/learn/interview'
// import eliminate from '@/components/pages/learn/eliminate'
// import sendoffer from '@/components/pages/learn/sendoffer'
// import personnel from '@/components/pages/learn/personnel'
// import post from '@/components/pages/learn/post'
// import department from '@/components/pages/learn/department'
// import hrinfo from '@/components/pages/learn/hrinfo'
// import application from '@/components/pages/learn/application'
// import signcode from '@/components/pages/learn/signcode'
// import channel from '@/components/pages/learn/channel'
// import telemplete from '@/components/pages/learn/telemplete'
// import eliminateReason from '@/components/pages/learn/eliminateReason'
// import renounce from '@/components/pages/learn/renounce'
// import backProcess from '@/components/pages/learn/backProcess'
// import backCenter from '@/components/pages/learn/backCenter'

import axiosRequire from '../axios/axiosRequire'

Vue.use(Router);

export const router = new Router({
  mode: 'history', 
  routes: [
    {
      path: '/',
      redirect: '/index'
    },
    {
      path: '/detail',
      name: 'detail',
      component: resovle => require(['@/components/web/detail.vue'],resovle)
    },
    {
      path: '/backendMod',
      name: 'backendMod',
      component: backendMod,
      children: [{
        path: '/index',
        name: 'index',
        component: index
      }, 
      {
        path: '/chrome',
        name: 'chrome',
        component: chrome
      },{
        path: '/download',
        name: 'download',
        component: download
      }, {
        path: '/service',
        name: 'service',
        component: service
      }, {
        path: '/price',
        name: 'price',
        component: price
      }, {
        path: '/about',
        name: 'about',
        component: about
      }, {
        path: '/casus',
        name: 'casus',
        component: casus
      }, {
        path: '/background',
        name: 'background',
        component: background
      }, {
        path: '/getEmail',
        name: 'getEmail',
        component: getEmail
      }, {
        path: '/sendEmail',
        name: 'sendEmail',
        component: sendEmail
      }, {
        path: '/jobs',
        name: 'jobs',
        component: jobs
      },
      {
        path: '/chrome',
        name: 'chrome',
        component: chrome
      },
      {
        path: '/chromeNew',
        name: 'chromeNew',
        component: chromeNew
      },
      {
        path: '/dingding',
        name: 'dingding',
        component: dingding
      },
      {
        path: '/qiwei',
        name: 'qiwei',
        component: qiwei
      },
      {
        path: '/customizedService',
        name: 'customizedService',
        component: customizedService
      },
      {
        path: '/cases',
        name: 'cases',
        component: cases
      },
      {
        path: '/whoAreWe',
        name: 'whoAreWe',
        component: whoAreWe
      },
      {
        path: '/channelsSupport',
        name: 'channelsSupport',
        component: channelsSupport
      },
      {
        path: '/downloadCenter',
        name: 'downloadCenter',
        component: downloadCenter
      },
      {
        path:'/learn',
        name:'learn',
        component:learn,
        redirect:'/learn1',
        children:[
          {
            path: '/learn1',
            name: 'learn1',
            component:  resolve => require(['@/components/pages/learn/learn1'], resolve) 
          },
          {
            path: '/learn2',
            name: 'learn2',
            component:  resolve => require(['@/components/pages/learn/learn2'], resolve) 
          },
          {
            path: '/learn3',
            name: 'learn3',
            component:  resolve => require(['@/components/pages/learn/learn3'], resolve) 
          },
          {
            path: '/learn4',
            name: 'learn4',
            component:  resolve => require(['@/components/pages/learn/learn4'], resolve) 
          },
          {
            path: '/learn5',
            name: 'learn5',
            component:  resolve => require(['@/components/pages/learn/learn5'], resolve) 
          },
          {
            path: '/learn6',
            name: 'learn6',
            component:  resolve => require(['@/components/pages/learn/learn6'], resolve) 
          },
          {
            path: '/learn7',
            name: 'learn7',
            component:  resolve => require(['@/components/pages/learn/learn7'], resolve) 
          },
          {
            path: '/learn8',
            name: 'learn8',
            component:  resolve => require(['@/components/pages/learn/learn8'], resolve) 
          },
          {
            path: '/learn9',
            name: 'learn9',
            component:  resolve => require(['@/components/pages/learn/learn9'], resolve) 
          },
          {
            path: '/learn10',
            name: 'learn10',
            component:  resolve => require(['@/components/pages/learn/learn10'], resolve) 
          },
          {
            path: '/learn11',
            name: 'learn11',
            component:  resolve => require(['@/components/pages/learn/learn11'], resolve) 
          },
          {
            path: '/learn12',
            name: 'learn12',
            component:  resolve => require(['@/components/pages/learn/learn12'], resolve) 
          },
          {
            path: '/learn13',
            name: 'learn13',
            component:  resolve => require(['@/components/pages/learn/learn13'], resolve) 
          },
          {
            path: '/learn14',
            name: 'learn14',
            component:  resolve => require(['@/components/pages/learn/learn14'], resolve) 
          },
          {
            path: '/learn15',
            name: 'learn15',
            component:  resolve => require(['@/components/pages/learn/learn15'], resolve) 
          },
          {
            path: '/learn9',
            name: 'learn9',
            component:  resolve => require(['@/components/pages/learn/learn9'], resolve) 
          },
          {
            path: '/learn16',
            name: 'learn16',
            component:  resolve => require(['@/components/pages/learn/learn16'], resolve) 
          },
          {
            path: '/learn17',
            name: 'learn17',
            component:  resolve => require(['@/components/pages/learn/learn17'], resolve) 
          },
          {
            path: '/learn18',
            name: 'learn18',
            component:  resolve => require(['@/components/pages/learn/learn18'], resolve) 
          },
          {
            path: '/learn19',
            name: 'learn19',
            component:  resolve => require(['@/components/pages/learn/learn19'], resolve) 
          },
          {
            path: '/learn20',
            name: 'learn20',
            component:  resolve => require(['@/components/pages/learn/learn20'], resolve) 
          },
          {
            path: '/learn21',
            name: 'learn21',
            component:  resolve => require(['@/components/pages/learn/learn21'], resolve) 
          },
          {
            path: '/learn22',
            name: 'learn22',
            component:  resolve => require(['@/components/pages/learn/learn22'], resolve) 
          },
          {
            path: '/learn20',
            name: 'learn20',
            component:  resolve => require(['@/components/pages/learn/learn20'], resolve) 
          },
          {
            path: '/learn23',
            name: 'learn23',
            component:  resolve => require(['@/components/pages/learn/learn23'], resolve) 
          },
          {
            path: '/learn24',
            name: 'learn24',
            component:  resolve => require(['@/components/pages/learn/learn24'], resolve) 
          },
          {
            path: '/learn25',
            name: 'learn25',
            component:  resolve => require(['@/components/pages/learn/learn25'], resolve) 
          },
          {
            path: '/learn26',
            name: 'learn26',
            component:  resolve => require(['@/components/pages/learn/learn26'], resolve) 
          },
          {
            path: '/learn27',
            name: 'learn27',
            component:  resolve => require(['@/components/pages/learn/learn27'], resolve) 
          },
          {
            path: '/learn28',
            name: 'learn28',
            component:  resolve => require(['@/components/pages/learn/learn28'], resolve) 
          },
          {
            path: '/learn29',
            name: 'learn29',
            component:  resolve => require(['@/components/pages/learn/learn29'], resolve) 
          },
          {
            path: '/learn30',
            name: 'learn30',
            component:  resolve => require(['@/components/pages/learn/learn30'], resolve) 
          },
          {
            path: '/learn31',
            name: 'learn31',
            component:  resolve => require(['@/components/pages/learn/learn31'], resolve) 
          },
          {
            path: '/learn32',
            name: 'learn32',
            component:  resolve => require(['@/components/pages/learn/learn32'], resolve) 
          },
          {
            path: '/learn33',
            name: 'learn33',
            component:  resolve => require(['@/components/pages/learn/learn33'], resolve) 
          },
          {
            path: '/learn34',
            name: 'learn34',
            component:  resolve => require(['@/components/pages/learn/learn34'], resolve) 
          },
          {
            path: '/learn35',
            name: 'learn35',
            component:  resolve => require(['@/components/pages/learn/learn35'], resolve) 
          },
          {
            path: '/learn36',
            name: 'learn36',
            component:  resolve => require(['@/components/pages/learn/learn36'], resolve) 
          },
          {
            path: '/learn37',
            name: 'learn37',
            component:  resolve => require(['@/components/pages/learn/learn37'], resolve) 
          },
          {
            path: '/learn38',
            name: 'learn38',
            component:  resolve => require(['@/components/pages/learn/learn38'], resolve) 
          },
          {
            path: '/learn39',
            name: 'learn39',
            component:  resolve => require(['@/components/pages/learn/learn39'], resolve) 
          },
          {
            path: '/learn40',
            name: 'learn40',
            component:  resolve => require(['@/components/pages/learn/learn40'], resolve) 
          },
          {
            path: '/learn41',
            name: 'learn41',
            component:  resolve => require(['@/components/pages/learn/learn41'], resolve) 
          },
          {
            path: '/learn42',
            name: 'learn42',
            component:  resolve => require(['@/components/pages/learn/learn42'], resolve) 
          },
          {
            path: '/learn43',
            name: 'learn43',
            component:  resolve => require(['@/components/pages/learn/learn43'], resolve) 
          },
          {
            path: '/learn44',
            name: 'learn44',
            component:  resolve => require(['@/components/pages/learn/learn44'], resolve) 
          },
          {
            path: '/learn45',
            name: 'learn45',
            component:  resolve => require(['@/components/pages/learn/learn45'], resolve) 
          },
        ]
      },{
        path: '/problem',
        name: 'problem',
        redirect:'/question',
        component: problem,
        children:[
          {
            path: '/question',
            name: 'question',
            component: resolve => require(['@/components/pages/problem/question'], resolve)
          },
          {
            path: '/question1',
            name: 'question1',
            component: resolve => require(['@/components/pages/problem/question1'], resolve)
          },
          {
            path: '/question2',
            name: 'question2',
            component: resolve => require(['@/components/pages/problem/question2'], resolve)
          },
          {
            path: '/question3',
            name: 'question3',
            component: resolve => require(['@/components/pages/problem/question3'], resolve)
          },
          {
            path: '/question4',
            name: 'question4',
            component: resolve => require(['@/components/pages/problem/question4'], resolve)
          },
          {
            path: '/question5',
            name: 'question5',
            component: resolve => require(['@/components/pages/problem/question5'], resolve)
          },
          {
            path: '/question6',
            name: 'question6',
            component: resolve => require(['@/components/pages/problem/question6'], resolve)
          },
          {
            path: '/question7',
            name: 'question7',
            component: resolve => require(['@/components/pages/problem/question7'], resolve)
          },
          {
            path: '/question8',
            name: 'question8',
            component: resolve => require(['@/components/pages/problem/question8'], resolve)
          },
          {
            path: '/question9',
            name: 'question9',
            component: resolve => require(['@/components/pages/problem/question9'], resolve)
          },
          {
            path: '/question10',
            name: 'question10',
            component: resolve => require(['@/components/pages/problem/question10'], resolve)
          },
          {
            path: '/question11',
            name: 'question11',
            component: resolve => require(['@/components/pages/problem/question11'], resolve)
          },
          {
            path: '/question12',
            name: 'question12',
            component: resolve => require(['@/components/pages/problem/question12'], resolve)
          },
          {
            path: '/question13',
            name: 'question13',
            component: resolve => require(['@/components/pages/problem/question13'], resolve)
          },
          {
            path: '/question14',
            name: 'question14',
            component: resolve => require(['@/components/pages/problem/question14'], resolve)
          },
          {
            path: '/question15',
            name: 'question15',
            component: resolve => require(['@/components/pages/problem/question15'], resolve)
          },
          {
            path: '/question16',
            name: 'question16',
            component: resolve => require(['@/components/pages/problem/question16'], resolve)
          },
          {
            path: '/question17',
            name: 'question17',
            component: resolve => require(['@/components/pages/problem/question17'], resolve)
          },
          {
            path: '/question18',
            name: 'question18',
            component: resolve => require(['@/components/pages/problem/question18'], resolve)
          },
          {
            path: '/question19',
            name: 'question19',
            component: resolve => require(['@/components/pages/problem/question19'], resolve)
          },
          {
            path: '/question20',
            name: 'question20',
            component: resolve => require(['@/components/pages/problem/question20'], resolve)
          },
          {
            path: '/question21',
            name: 'question21',
            component: resolve => require(['@/components/pages/problem/question21'], resolve)
          },
          {
            path: '/question22',
            name: 'question22',
            component: resolve => require(['@/components/pages/problem/question22'], resolve)
          },
          {
            path: '/question23',
            name: 'question23',
            component: resolve => require(['@/components/pages/problem/question23'], resolve)
          },
          {
            path: '/question24',
            name: 'question24',
            component: resolve => require(['@/components/pages/problem/question24'], resolve)
          },
          {
            path: '/question25',
            name: 'question25',
            component: resolve => require(['@/components/pages/problem/question25'], resolve)
          },
          {
            path: '/question26',
            name: 'question26',
            component: resolve => require(['@/components/pages/problem/question26'], resolve)
          },
          {
            path: '/question27',
            name: 'question27',
            component: resolve => require(['@/components/pages/problem/question27'], resolve)
          },
          {
            path: '/question28',
            name: 'question28',
            component: resolve => require(['@/components/pages/problem/question28'], resolve)
          },
          {
            path: '/question29',
            name: 'question29',
            component: resolve => require(['@/components/pages/problem/question29'], resolve)
          },
          {
            path: '/question30',
            name: 'question30',
            component: resolve => require(['@/components/pages/problem/question30'], resolve)
          },
          {
            path: '/question31',
            name: 'question31',
            component: resolve => require(['@/components/pages/problem/question31'], resolve)
          },
          {
            path: '/question32',
            name: 'question32',
            component: resolve => require(['@/components/pages/problem/question32'], resolve)
          },
          {
            path: '/question33',
            name: 'question33',
            component: resolve => require(['@/components/pages/problem/question33'], resolve)
          },
          {
            path: '/question34',
            name: 'question34',
            component: resolve => require(['@/components/pages/problem/question34'], resolve)
          },
          {
            path: '/question35',
            name: 'question35',
            component: resolve => require(['@/components/pages/problem/question35'], resolve)
          },
          {
            path: '/question36',
            name: 'question36',
            component: resolve => require(['@/components/pages/problem/question36'], resolve)
          },
          {
            path: '/question37',
            name: 'question37',
            component: resolve => require(['@/components/pages/problem/question37'], resolve)
          },
          {
            path: '/question38',
            name: 'question38',
            component: resolve => require(['@/components/pages/problem/question38'], resolve)
          },
          {
            path: '/question39',
            name: 'question39',
            component: resolve => require(['@/components/pages/problem/question39'], resolve)
          },
          {
            path: '/question40',
            name: 'question40',
            component: resolve => require(['@/components/pages/problem/question40'], resolve)
          },
          {
            path: '/question41',
            name: 'question41',
            component: resolve => require(['@/components/pages/problem/question41'], resolve)
          },
          {
            path: '/question42',
            name: 'question42',
            component: resolve => require(['@/components/pages/problem/question42'], resolve)
          },
          {
            path: '/question43',
            name: 'question43',
            component: resolve => require(['@/components/pages/problem/question43'], resolve)
          },
          {
            path: '/question44',
            name: 'question44',
            component: resolve => require(['@/components/pages/problem/question44'], resolve)
          },
          {
            path: '/question45',
            name: 'question45',
            component: resolve => require(['@/components/pages/problem/question45'], resolve)
          },
          {
            path: '/question46',
            name: 'question46',
            component: resolve => require(['@/components/pages/problem/question46'], resolve)
          },
        ]
      }
    ]
    }
  ]
});
router.beforeEach((to, from, next) => {
  // if (to.name != 'login') {
  //   if (from.name == 'login') {
  //     next();
  //   } else {
  //     axiosRequire('/backend/admin/checkLogin', 'post').then(data => {
  //       if (data.code === 200) {
  //         next()
  //       } else {
  //         next({
  //           name: 'login'
  //         })
  //       }
  //     });
  //   }
  // } else {
  //   next()
  // }
  next();
});



// WEBPACK FOOTER //
// ./src/router/index.js